import React, {useState, useEffect} from 'react';
import useExtendedEffect from '../../../../utilities/hooks/useExtendedEffect';
import {connect} from 'react-redux';
import {Container, Row, Col} from 'reactstrap';
import SubscriberHeader from '../Shared/SubscriberHeder/SubscriberHeader'
import SongListPreview from '../Shared/SongListPreview/SongListPreview';
import MyPlaylist from '../Shared/MyPlaylist/MyPlaylist';
import SettingSong from '../Shared/SettingSong/SettingSong'
import {goToPage, setTitle, getCategory, getGallery, setShuffle, setDefaultSong, pageLoaded, setDefaultSongSetting, setIsDefaultSong, setStripMassage} from '../fundialSlice';
import { showAppLoader, hideAppLoader } from '../../../Shared/Loader/LoaderSlice';
import emptyDefaultSong from '../Shared/SettingSong/images/emptyDefaultSong.svg';
import DownloadSongPopUp from '../Shared/DownloadSongPopUp/DownloadSongPopUp'


const PersonalAreaPage = (props) => {
  const [isClickedSongPreviewButton, setIsClickedSongPreviewButton] = useState(false);
  const categoryId = 15624;

  useExtendedEffect((runSideEffects) => { 
    window.scrollTo(0, 0);
    props.setTitle({titleBold: "המתנה נעימה" , titleRegular: "ניהול"})
    getPersonalAreaData();
    if (runSideEffects()) {
    }
  }, []);

  useExtendedEffect((runSideEffects) => { 
    if (runSideEffects()) {
      setDefaultSongForSetting();
    }
  }, [props.subscriberGallery]);

  useExtendedEffect((runSideEffects) => { 
    if(isClickedSongPreviewButton){
        if(props.isFinishedGetGallery){
          props.hideAppLoader();
          props.pageLoaded(); 
          props.goToPage({page: 'catalogPage'});
        }
        else {
          props.showAppLoader();
        }
    }
  }, [props.isFinishedGetGallery, isClickedSongPreviewButton]);

  function handleOnClick_SongListPreview(){
    setIsClickedSongPreviewButton(true);
  }

  async function getPersonalAreaData() {
    props.showAppLoader();
    await Promise.all([props.getCategory(categoryId), props.getGallery({subscriber: props.subscriber.cli })]);
    setDefaultSongForSetting();
    props.hideAppLoader(); 
  }

  function setDefaultSongForSetting(){
    let song = null;
    props.subscriberGallery?.items?.item.forEach(item => {
        if(item.isDefault == "true"){
            song = {
                image: item.image,
                funtonPrevUrl: item.funtonPrevUrl,
                description: item.title,
                author: item.artists.artistName, 
                id: item.productId ,
                isSelected: !props.subscriberGallery.isShuffle ? true  : false                
            }
            return;
        }
    });

    if(!song){
       song ={
            image: emptyDefaultSong,
            description: "שיר ברירת מחדל",
            author: "ניתן לבחור שיר ברירת מחדל אחר מהפלייליסט שלך", 
            id: "defaultSong" ,
            isSelected: !props.subscriberGallery?.isShuffle ? true  : false           
        };

    }

    props.setDefaultSongSetting(song);

    if(song.isSelected)
      props.setIsDefaultSong(true);   
    else
      props.setIsDefaultSong(false);

      props.pageLoaded();     

  }

 async function onSettings(defaultSong) {
    if(defaultSong){//set to default song       
        await props.setShuffle({subscriber: props.subscriber.cli , profileId: props.subscriberGallery.shuffleProfileId , isSetShuffle: false });
        props.pageLoaded();     

    }
    else{//set to random        
        await props.setShuffle({subscriber: props.subscriber.cli , profileId: "" , isSetShuffle: true  });
        props.pageLoaded();     

    }
}

  function view(){
      return (
        <div>
          <Row className="justify-content-lg-center">
            <Col xs='12' sm='12' md='12' lg='8'>
              <SubscriberHeader />
              <div className="component-separator"></div>
              <SettingSong  onSettings={onSettings}></SettingSong>
              <div className="component-separator"></div>
              <MyPlaylist data={props.subscriberGallery} ></MyPlaylist>
            </Col>
          </Row>
          <div className="component-separator"></div>
          {props.catagories[categoryId] &&
          <Row className="justify-content-lg-center">
          <Col xs='12' sm='12' md='12' lg='12'>
            <SongListPreview
              items={props.catagories[categoryId].items}
              title='הורידו שיר'
              subTitle='חדש'
              buttonText='לכל השירים'
              onclick={handleOnClick_SongListPreview}
            />
          </Col>
          </Row>
          }
          <DownloadSongPopUp  />
        </div>
      );   
  }


  return (
    <div className='personal-area-page'>
       {view()}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    subscriber : state.fundialPage.selectedSubscriber,
    subscriberGallery: state.fundialPage.subscriberGallery,
    catagories: state.fundialPage.catagories, 
    stripMassage : state.fundialPage.stripMassage,
    isFinishedGetGallery: state.fundialPage.pages.personalAreaPage.isFinishedGetGallery
  };
};

const mapDispatchToProps = {
  goToPage,
  setTitle,
  showAppLoader, 
  hideAppLoader,
  getCategory, 
  getGallery,
  setShuffle,
  setDefaultSong,
  setDefaultSongSetting,
  setIsDefaultSong,
  pageLoaded,
  setStripMassage
};

export default connect(mapStateToProps, mapDispatchToProps)(PersonalAreaPage);
